const t = "btn_jMg-N", n = "btn__primary_uoZL2", _ = {
  btn: t,
  btn__primary: n
};
export {
  t as btn,
  n as btn__primary,
  _ as default
};
//# sourceMappingURL=landingButton.module.scss.js.map
